
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_w1dso_93",
  "input": "awsui_input_2rhyz_w1dso_97",
  "input-readonly": "awsui_input-readonly_2rhyz_w1dso_147",
  "input-invalid": "awsui_input-invalid_2rhyz_w1dso_214",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_w1dso_225",
  "input-type-search": "awsui_input-type-search_2rhyz_w1dso_230",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_w1dso_246",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_w1dso_249",
  "input-container": "awsui_input-container_2rhyz_w1dso_256",
  "input-icon-left": "awsui_input-icon-left_2rhyz_w1dso_261",
  "input-icon-right": "awsui_input-icon-right_2rhyz_w1dso_268",
  "input-button-right": "awsui_input-button-right_2rhyz_w1dso_274"
};
  